// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#badge[data-v-ea8219fc] {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  width: 600px;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
